import { render } from "./ConfigurarFichaEpi.vue?vue&type=template&id=1597c6ee&scoped=true"
import script from "./ConfigurarFichaEpi.vue?vue&type=script&lang=js"
export * from "./ConfigurarFichaEpi.vue?vue&type=script&lang=js"

import "./ConfigurarFichaEpi.vue?vue&type=style&index=0&id=1597c6ee&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1597c6ee"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QInput,QBtn,QFile,QSelect,QIcon,QRadio});
